import type { Session } from '@/api/client';
import {
  normalizeHaystackForMatch,
  normalizeForSearchHighlight,
} from '@/utils/highlightSearchTerms';

function getSessionReaderNames(session: Session): string {
  return session.readers?.length
    ? session.readers.map((r) => r.name).join(', ')
    : (session.reader_name?.trim() || '');
}

/** Объединённое текстовое поле для поиска по сессии (как отображается в пузырьке + тип/подкаст). */
export function buildSessionScheduleSearchHaystack(session: Session): string {
  const parts: string[] = [];
  parts.push(getSessionReaderNames(session));
  parts.push(session.project_name ?? '');
  parts.push(session.soundengineer_name ?? '');
  parts.push(String(session.session_type ?? ''));
  if (session.session_subtype === 'podcast') parts.push('подкаст');
  parts.push(session.title ?? '');
  parts.push(session.content ?? '');
  return parts.filter((p) => p && String(p).trim() !== '').join('\n');
}

/** Каждое слово из `words` должно встретиться в игле (логическое И), без учёта регистра. */
export function sessionMatchesScheduleSearchWords(session: Session, words: string[]): boolean {
  if (words.length === 0) return true;
  const hay = normalizeHaystackForMatch(buildSessionScheduleSearchHaystack(session)).toLowerCase();
  for (const w of words) {
    const nw = normalizeForSearchHighlight(w).toLowerCase();
    if (!nw || !hay.includes(nw)) return false;
  }
  return true;
}
